import { AgResourceLanguage } from '../types';
import { sharePacks as EnUsSharePacks } from '../en-us/sharePacks';

export const sharePacks: AgResourceLanguage['sharePacks'] = {
  ...EnUsSharePacks,
  shippingFields: {
    ...EnUsSharePacks.shippingFields,
    title: '¿A dónde enviamos este regalo gratuito?',
    subtitle:
      'Tu amigo recibirá sus paquetes de viaje AG1 dentro de 3 a 5 días hábiles. Puedes seguir la entrega en tu historial de pedidos.',
    email: 'Correo Electrónico del Amigo',
    giftMessage: 'Mensaje de Regalo (máximo 500 caracteres)',
    country: 'País/región',
    firstName: 'Nombre',
    lastName: 'Apellido',
    addressLine1: 'Dirección',
    addressLine2: 'Apartamento, Suite, Etc (opcional)',
    city: 'Ciudad',
    state: 'Provincia',
    zipCode: 'Código Postal',
    phone: 'Teléfono',
    submitButtonText: 'Guardar',
    cancelButtonText: 'Cancelar',
    label: 'Enviar como regalo',
    caption: `
    <p>Al realizar este pedido, aceptas los 
      <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Términos y Condiciones</a> 
      y&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Política de Privacidad</a>.
    </p>
  `
  },
  commonError: 'Algo salió mal. Inténtalo de nuevo más tarde.',
  title: 'Comparte Paquetes de Viaje GRATIS de AG1 con tus amigos:',
  subtitle:
    'Dales una muestra de lo bien que se siente tomar el control de su salud, con un paquete de 5 — por nuestra cuenta.*',
  disclosure:
    '*Limitado a suscriptores activos. La oferta de Paquetes de Viaje AG1 gratis es válida por 30 días desde la notificación. Los Paquetes de Viaje AG1 gratis no son transferibles, deben canjearse a través del portal de miembros y solo se pueden enviar a direcciones en EE. UU. Límite de tres Paquetes de Viaje AG1 por cliente calificado.',
  status: {
    shared: 'Ya has compartido todos tus paquetes',
    expired:
      'El programa piloto para compartir Paquetes Gratis ha finalizado, ¡vuelve más tarde para más!',
    limited: 'Programa Temporal',
    expiring: 'La oferta de Paquetes de Viaje Gratis expira el {{date}}.'
  },
  button: {
    ...EnUsSharePacks.button,
    share: 'Comparte 5 Paquetes de Viaje',
    expired: 'Expirado',
    viewOrder: 'Ver Pedido',
    shared: 'Compartido'
  },
  modal: {
    ...EnUsSharePacks.modal,
    head: 'Comparte Paquetes de Viaje Gratis',
    title: '¿A dónde enviamos este regalo gratuito?',
    subtitle:
      'Tu amigo recibirá sus paquetes de viaje AG1 dentro de 3 a 5 días hábiles. Puedes seguir la entrega en tu historial de pedidos.'
  },
  checkout: {
    ...EnUsSharePacks.checkout,
    success: 'Tu pedido ha sido creado con éxito.'
  },
  subscriptionFreeGiftName: 'Comparte Paquetes Gratis',
  buttonTrack: 'Seguir Pedido',
  freeGiftPrice: 'Gratis',
  subscriptionNameLabel: 'Tipo de Pedido'
};
